import type { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';
import type { EventReportEntryInterface } from '@zaoblako/shared/modules/cctv/dtos/event-report/event-report-entry.dto';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import { PASSAGE_FORM_ROOM_CATEGORY_FILTER_EMPTY, PASSAGE_FORM_ROOM_CATEGORY_FILTER_NOT_BOUND, PASSAGE_FORM_ROOM_IDS_COMPARE_SEPARATOR, type PassageFormRoomCategoryFilterIds } from '@zaoblako/web/modules/passage/utils/passage-form-room-category-filters.const';

import { compact, isNil } from 'lodash';

const normalizeRoomIds = (rooms?: RoomFindInterface[] | null): number[] => compact((rooms ?? []).map((room) => room?.id));

/** Filial IDs for room dropdown when client is set */
export const getRoomFilialIdsFilterForClient = (client?: ClientFindInterface | null): PassageFormRoomCategoryFilterIds => {
  if (isNil(client?.id)) {
    return PASSAGE_FORM_ROOM_CATEGORY_FILTER_NOT_BOUND;
  }

  const filialIds = compact((client.filials ?? []).map((filial) => filial?.id));

  return filialIds.length ? filialIds : PASSAGE_FORM_ROOM_CATEGORY_FILTER_EMPTY;
};

/** Room IDs for car category dropdown */
export const getCategoryFilterRoomIds = (rooms?: RoomFindInterface[] | null): PassageFormRoomCategoryFilterIds => {
  const roomIds = normalizeRoomIds(rooms);

  return roomIds.length ? roomIds : PASSAGE_FORM_ROOM_CATEGORY_FILTER_EMPTY;
};

/** Event camera room IDs for guest pass category filter */
export const getEventCameraRoomIdsFilter = (eventItem?: EventReportEntryInterface | null): PassageFormRoomCategoryFilterIds => {
  if (isNil(eventItem)) {
    return PASSAGE_FORM_ROOM_CATEGORY_FILTER_NOT_BOUND;
  }

  const ids = compact(eventItem.cameraRoomIds);

  return ids.length ? ids : PASSAGE_FORM_ROOM_CATEGORY_FILTER_EMPTY;
};

export const haveRoomIdsChanged = (
  previousRooms?: RoomFindInterface[] | null,
  nextRooms?: RoomFindInterface[] | null
): boolean => {
  const prevKey = normalizeRoomIds(previousRooms).sort((a, b) => a - b).join(PASSAGE_FORM_ROOM_IDS_COMPARE_SEPARATOR);
  const nextKey = normalizeRoomIds(nextRooms).sort((a, b) => a - b).join(PASSAGE_FORM_ROOM_IDS_COMPARE_SEPARATOR);

  return prevKey !== nextKey;
};
